import { render, staticRenderFns } from "./WorkCalendarSidebar.vue?vue&type=template&id=4ba9d3a8&scoped=true"
import script from "./WorkCalendarSidebar.vue?vue&type=script&lang=js"
export * from "./WorkCalendarSidebar.vue?vue&type=script&lang=js"
import style0 from "./WorkCalendarSidebar.vue?vue&type=style&index=0&id=4ba9d3a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba9d3a8",
  null
  
)

export default component.exports